(() => {
  const initialise = () => {
    const marketingConsent = document.getElementById('accepts_marketing');
    if (marketingConsent && !marketingConsent.dataset.meraiConsentInitialised) {
      marketingConsent.checked = false;
      marketingConsent.dataset.meraiConsentInitialised = 'true';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();